import type { Product } from "@/types/product";

import type { APIInstance } from "./apiService";

export class ProductService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async fetchProducts(): Promise<Product[]> {
    const response = await this.api.get<Product[]>("/public/products", {
      params: {
        include_prices: true,
      },
    });
    return response.data;
  }
}
